import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoService } from '@jsverse/transloco';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import { HeaderService } from 'core';
import { RouterLink } from '@angular/router';

enum PricelistStatus {
  OK = 'ok',
  WARN = 'warn',
  ERR = 'err',
}

interface PricelistMock {
  id: number;
  numeroContratto: string;
  cliente: string;
  inizio: Date;
  fine: Date;
  righe: number;
  agente: string;
  stato: PricelistStatus;
}

@Component({
  selector: 'lis-pricelists-list',
  imports: [RouterLink, TranslocoDatePipe, MatFormFieldModule, MatInputModule, MatChipsModule, MatDividerModule],
  templateUrl: './pricelists-list.html',
  styleUrl: './pricelists-list.scss',
})
export class PricelistsList implements OnInit, OnDestroy {
  private readonly headerService = inject(HeaderService);
  private readonly translocoService = inject(TranslocoService);

  readonly statusLabels: Record<PricelistStatus, string> = {
    [PricelistStatus.OK]: 'Attivo',
    [PricelistStatus.WARN]: 'In approvazione',
    [PricelistStatus.ERR]: 'Scaduto',
  };

  readonly mockItems: PricelistMock[] = [
    {
      id: 1,
      numeroContratto: 'CT-2025-014',
      cliente: 'Industrie Metalliche S.p.a.',
      inizio: new Date(2026, 0, 1),
      fine: new Date(2026, 11, 31),
      righe: 8,
      agente: 'Agente X',
      stato: PricelistStatus.OK,
    },
    {
      id: 2,
      numeroContratto: 'CT-2025-031',
      cliente: 'Azienda Agricola Rossi',
      inizio: new Date(2025, 8, 1),
      fine: new Date(2026, 2, 10),
      righe: 5,
      agente: 'Agente Y',
      stato: PricelistStatus.OK,
    },
    {
      id: 3,
      numeroContratto: 'Senza contratto',
      cliente: 'Carrozzeria San Carlo',
      inizio: new Date(2026, 1, 10),
      fine: new Date(2026, 7, 10),
      righe: 6,
      agente: 'Agente Z',
      stato: PricelistStatus.WARN,
    },
    {
      id: 4,
      numeroContratto: 'CT-2024-088',
      cliente: 'F.lli Fumagalli snc',
      inizio: new Date(2024, 5, 1),
      fine: new Date(2025, 4, 31),
      righe: 4,
      agente: 'Agente X',
      stato: PricelistStatus.ERR,
    },
    {
      id: 5,
      numeroContratto: 'CT-2025-002',
      cliente: 'Autofficina di Mario',
      inizio: new Date(2026, 0, 15),
      fine: new Date(2026, 6, 15),
      righe: 3,
      agente: 'Agente X',
      stato: PricelistStatus.OK,
    },
    {
      id: 6,
      numeroContratto: 'CT-2026-005',
      cliente: 'F.lli Fumagalli snc',
      inizio: new Date(2026, 2, 1),
      fine: new Date(2026, 8, 1),
      righe: 1,
      agente: 'Agente X',
      stato: PricelistStatus.WARN,
    },
  ];

  ngOnInit(): void {
    this.translocoService.selectTranslation('pricelists').subscribe(() => {
      this.headerService.setTitle(
        this.translocoService.translate('header', {}, 'pricelists'),
      );
    });

    this.headerService.setActions([
      {
        label: 'Mostra o nascondi filtri',
        icon: 'fa-filter',
        action: () => undefined,
      },
    ]);
  }

  ngOnDestroy(): void {
    this.headerService.removeTitle();
    this.headerService.removeActions();
  }
}
